export default {
  "contact": "संपर्क",
  "us": "हमसे",
  "contact_description": "कोई प्रश्न है, सुझाव देना है, या व्यक्तिगत परामर्श चाहिए? हमसे संपर्क करें और हम 24–48 घंटे में उत्तर देंगे।",

  "email": "ईमेल",
  "phone_whatsapp": "फोन / व्हाट्सएप",
  "chat_on_whatsapp": "व्हाट्सएप पर चैट करें",
  "follow_us": "हमारा अनुसरण करें",

  "full_name": "पूरा नाम",
  "email_address": "ईमेल पता",
  "phone_number": "फ़ोन नंबर",
  "subject": "विषय",
  "message": "संदेश",

  "enter_full_name": "अपना पूरा नाम दर्ज करें",
  "email_placeholder": "you@email.com",
  "phone_placeholder": "वैकल्पिक: +91 xxxxx-xxxxx",
  "subject_placeholder": "हम आपकी किस प्रकार मदद कर सकते हैं?",
  "message_placeholder": "हमें बताएं कि आपकी ज्योतिषीय ज़रूरतों में हम कैसे मदद कर सकते हैं...",

  "send_message": "संदेश भेजें",
  "message_sent_success": "संदेश भेजा गया! ✓",
  "thank_you_message": "हमसे संपर्क करने के लिए धन्यवाद! हम 24–48 घंटे में उत्तर देंगे।"
};
